import { render } from "./EditSalesPage.vue?vue&type=template&id=37a594da&ts=true"
import script from "./EditSalesPage.vue?vue&type=script&lang=ts"
export * from "./EditSalesPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__